import { getHotelCenterService } from '@bingads-webui-campaign/hotel-center-service';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const dataStore = globalContext.require('component/js-data-campaign/index');
const state = globalContext.require('component/state/index');
const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');

export const {
  gridOptionUtils,
  bulkEditParams,
  bulkEditService,
} = getHotelCenterService({ state, edm, dataStore });
